/**
 * @generated SignedSource<<212bf4854a0ee74a669baec50eab82ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CleanupProjectPageUseIsReadOnlyFragment$data = {
  readonly project: ReadonlyArray<{
    readonly rawId: string | null;
  }> | null;
  readonly " $fragmentType": "CleanupProjectPageUseIsReadOnlyFragment";
};
export type CleanupProjectPageUseIsReadOnlyFragment$key = {
  readonly " $data"?: CleanupProjectPageUseIsReadOnlyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CleanupProjectPageUseIsReadOnlyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CleanupProjectPageUseIsReadOnlyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectRest",
      "kind": "LinkedField",
      "name": "project",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Projects",
  "abstractKey": null
};

(node as any).hash = "67b97a9ee7cce1d2abf5347e2d2f0afb";

export default node;
